const type = {
  Male: 0,
  Female: 1
};

export default type;
